import React from "react";
import { get } from "lodash";

const RootCard = ({ root }) => {
  const uuid = get(root, "uuid");

  return (
    <a className="thinCard" href={`/node?uuid=${uuid}`}>
      <span>{root?.name || ""}</span>
    </a>
  );
};
export default RootCard;
